/* Copyright 2021, Milkdown by Mirone. */
import { findParentNode } from '@milkdown/utils';
import { TextSelection } from 'prosemirror-state';
export const hasMark = (editorState, type) => {
    const { from, to } = editorState.selection;
    return editorState.doc.rangeHasMark(from, from === to ? to + 1 : to, type);
};
export const isTextSelection = (editorState) => {
    const { selection } = editorState;
    if (selection instanceof TextSelection) {
        const text = editorState.doc.textBetween(selection.from, selection.to);
        if (!text)
            return false;
        return true;
    }
    return false;
};
export const isInCodeFence = (editorState) => Boolean(findParentNode((node) => !!node.type.spec.code)(editorState.selection));
export const isTextAndNotHasMark = (editorState, mark) => !isTextSelection(editorState) || isInCodeFence(editorState) || hasMark(editorState, mark);
export const equalNodeType = (nodeType, node) => {
    return (Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1) || node.type === nodeType;
};
//# sourceMappingURL=prosemirror.js.map